import { css } from "@emotion/react";

export const mainContainer = css`
    display: flex;
    border: 1px solid #ddd;
    background-color: #fff;
    margin: auto;
    height: 203px;
    justify-content: space-between;
    flex-direction: row;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`

export const col = css`
    display: flex;
    width: 33%;
    flex-direction: column;
    border-right: 1px solid #eee;
    &:last-of-type {
        border-right: none;
    }
`

export const header = css`
    display: flex;
    height: 35px;
    align-items: center;
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    color: #002755;
    padding-left: 15px;
    background-color: #f9f9f9;
    border-bottom: 1px solid #eee;
`

export const content = css`
    float: left;
    text-align: left;
    padding: 5px;
    height: 175px;
    overflow-y: auto;
    font-size: 14px;
    background-color: white;

    &::-webkit-scrollbar {
        width: 5px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
        background-color: #f1f1f1;
    }

    &:hover {
        background-color: #fcfcfc;
    }
`

export const tipText = css`
    font-size: 13px;
    padding: 10px;
    line-height: 1.6;
    color: #333;
`